import { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import axios from "axios";
import { useToast } from './components/userToast'
import { BASE_URL } from "./baseurl";
function LabBackground() {
  return (
    <svg
      className="absolute inset-0 w-full h-full z-0"
      viewBox="0 0 1440 900"
      preserveAspectRatio="xMidYMid slice"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <radialGradient id="bgGlow" cx="50%" cy="30%" r="80%">
          <stop offset="0%" stopColor="#0f2e28" />
          <stop offset="55%" stopColor="#0a1512" />
          <stop offset="100%" stopColor="#050807" />
        </radialGradient>
        <pattern id="grid" width="60" height="60" patternUnits="userSpaceOnUse">
          <path d="M60 0H0V60" fill="none" stroke="#14b8a6" strokeOpacity="0.06" strokeWidth="1" />
        </pattern>
      </defs>

      <rect width="1440" height="900" fill="url(#bgGlow)" />
      <rect width="1440" height="900" fill="url(#grid)" />

      <g stroke="#14b8a6" strokeOpacity="0.18" strokeWidth="1.5" fill="none">
        <line x1="180" y1="120" x2="340" y2="220" />
        <line x1="340" y1="220" x2="300" y2="380" />
        <line x1="340" y1="220" x2="500" y2="180" />
        <line x1="1120" y1="700" x2="1260" y2="600" />
        <line x1="1260" y1="600" x2="1260" y2="440" />
        <line x1="1260" y1="600" x2="1380" y2="680" />
      </g>
      <g fill="#14b8a6" fillOpacity="0.35">
        <circle cx="180" cy="120" r="5" />
        <circle cx="340" cy="220" r="7" />
        <circle cx="300" cy="380" r="4" />
        <circle cx="500" cy="180" r="4" />
        <circle cx="1120" cy="700" r="4" />
        <circle cx="1260" cy="600" r="7" />
        <circle cx="1260" cy="440" r="4" />
        <circle cx="1380" cy="680" r="5" />
      </g>
    </svg>
  );
}

export default function Login() {
  const navigate = useNavigate();
  const toast = useToast();
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const res = await axios.post(
        `${BASE_URL}/auth/login`,
        {
          email: formData.email,
          password: formData.password,
        }
      );

      localStorage.setItem("token", res.data.token);
      localStorage.setItem("user", JSON.stringify(res.data.user));

      toast({
        variant: "success",
        title: "Welcome back",
        description: "Redirecting you now...",
      });

      setTimeout(() => navigate("/"), 800);
    } catch (err) {
      toast({
        variant: "error",
        title: "Login failed",
        description:
          err.response?.data?.message || "Invalid email or password",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="relative w-full min-h-screen flex items-center justify-center overflow-hidden bg-[#050807]">
      <LabBackground />
      <div className="absolute inset-0 bg-black/30 z-10" />

      <div className="relative z-20 w-full max-w-[420px] mx-6 bg-black/50 backdrop-blur-md border border-white/10 rounded-2xl p-10">
        <div className="flex flex-col items-center mb-8">
        <div className="h-24 w-24 rounded-full overflow-hidden flex items-center justify-center bg-teal-500">
  <img 
    src="/logo.png" 
    alt="Futura Bio Labs" 
    className="w-full h-full object-cover"
  />
</div>
          <p className="text-gray-300 text-[15px] mt-2">
            Sign in to your account
          </p>
        </div>

        <form onSubmit={handleSubmit} className="flex flex-col gap-5">
          <div>
            <label className="block text-gray-300 text-sm font-medium mb-2">
              Email
            </label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              placeholder="you@example.com"
              className="w-full bg-white/5 border border-white/20 rounded-full px-5 py-3 text-white text-sm placeholder:text-gray-500 focus:outline-none focus:border-teal-500 focus:ring-1 focus:ring-teal-500"
            />
          </div>

          <div>
            <label className="block text-gray-300 text-sm font-medium mb-2">
              Password
            </label>
            <input
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
              placeholder="••••••••"
              className="w-full bg-white/5 border border-white/20 rounded-full px-5 py-3 text-white text-sm placeholder:text-gray-500 focus:outline-none focus:border-teal-500 focus:ring-1 focus:ring-teal-500"
            />
          </div>

          <div className="flex items-center justify-between text-sm -mt-1">
            <label className="flex items-center gap-2 text-gray-400">
              <input type="checkbox" className="accent-teal-500" />
              Remember me
            </label>
            <NavLink to="/forgot-password" className="text-teal-400 hover:text-teal-300">
              Forgot password?
            </NavLink>
          </div>

          <button
            type="submit"
            disabled={loading}
            className="gold-glow-btn w-full bg-white hover:bg-gray-200 text-black font-semibold text-[15px] rounded-full py-3 mt-2 transition-colors disabled:opacity-60 disabled:cursor-not-allowed"
          >
            {loading ? "SIGNING IN..." : "SIGN IN"}
          </button>
        </form>

        <p className="text-center text-gray-400 text-sm mt-7">
          Don't have an account?{" "}
          <NavLink to="/register" className="text-teal-400 hover:text-teal-300 font-medium">
            Create one
          </NavLink>
        </p>
      </div>
    </section>
  );
}